class CustomBISPopup {
  constructor() {
    this.overlay = document.getElementById('custom-bis-popup');
    if (!this.overlay) return;

    this.closeBtn = this.overlay.querySelector('.bis-popup-close');
    this.form = document.getElementById('bis-form');
    this.emailInput = /** @type {HTMLInputElement | null} */ (document.getElementById('bis-email'));
    this.phoneInput = /** @type {HTMLInputElement | null} */ (document.getElementById('bis-phone'));
    this.fieldEmail = document.getElementById('bis-field-email');
    this.fieldPhone = document.getElementById('bis-field-phone');
    this.gdprCheckbox = /** @type {HTMLInputElement | null} */ (document.getElementById('bis-gdpr'));
    this.submitBtn = document.getElementById('bis-submit');
    this.successMsg = this.overlay.querySelector('.bis-success-msg');
    this.errorMsg = this.overlay.querySelector('.bis-error-msg');
    this.channelBtns = this.overlay.querySelectorAll('.bis-channel-btn');

    this.productId = this.overlay.getAttribute('data-product-id');
    this.variantId = null;
    this.channel = 'email';

    this.KLAVIYO_COMPANY_ID = 'WRW64u';

    // Move overlay to <body> to escape overflow:scroll on ancestor containers
    document.body.appendChild(this.overlay);

    this.initEvents();
  }

  initEvents() {
    document.getElementById('custom-oos-btn')?.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    this.form?.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });

    this.channelBtns?.forEach((btn) => {
      btn.addEventListener('click', () => this.switchChannel(btn.getAttribute('data-channel') ?? 'email'));
    });
  }

  /** @param {string} channel */
  switchChannel(channel) {
    this.channel = channel;

    this.channelBtns?.forEach((btn) => {
      btn.classList.toggle('active', btn.getAttribute('data-channel') === channel);
    });

    this.emailInput?.classList.remove('error');
    this.phoneInput?.classList.remove('error');

    if (channel === 'sms') {
      this.fieldEmail.style.display = 'none';
      this.fieldPhone.style.display = '';
      this.phoneInput?.focus();
    } else {
      this.fieldPhone.style.display = 'none';
      this.fieldEmail.style.display = '';
      this.emailInput?.focus();
    }
  }

  getCurrentVariantId() {
    return document.querySelector('.variants-container .switcher-content input[type="radio"]:checked')?.getAttribute('value') || null;
  }

  open() {
    this.variantId = this.getCurrentVariantId();
    this.reset();
    this.overlay.classList.add('open');
    this.overlay.setAttribute('aria-hidden', 'false');
    setTimeout(() => this.emailInput?.focus(), 50);
  }

  close() {
    this.overlay.classList.remove('open');
    this.overlay.setAttribute('aria-hidden', 'true');
  }

  reset() {
    this.form?.reset();
    this.emailInput?.classList.remove('error');
    this.phoneInput?.classList.remove('error');
    this.successMsg.style.display = 'none';
    this.errorMsg.style.display = 'none';
    this.form.style.display = '';
    this.submitBtn?.removeAttribute('disabled');
    this.switchChannel('email');
  }

  async submit() {
    if (!this.gdprCheckbox?.checked) return;

    let profileAttributes = {};

    if (this.channel === 'sms') {
      const phone = this.phoneInput?.value.trim() ?? '';
      if (!this.isValidPhone(phone)) {
        this.phoneInput.classList.add('error');
        this.phoneInput.focus();
        return;
      }
      profileAttributes.phone_number = phone;
    } else {
      const email = this.emailInput?.value.trim() ?? '';
      if (!this.isValidEmail(email)) {
        this.emailInput.classList.add('error');
        this.emailInput.focus();
        return;
      }
      profileAttributes.email = email;
    }

    this.submitBtn?.setAttribute('disabled', 'true');

    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.KLAVIYO_COMPANY_ID}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: [this.channel === 'sms' ? 'SMS' : 'EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes,
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${this.variantId}`,
                  },
                },
              },
            },
          }),
        }
      );

      if (res.ok || res.status === 202) {
        this.form.style.display = 'none';
        this.successMsg.style.display = '';
      } else {
        throw new Error(res.status);
      }
    } catch {
      this.submitBtn?.removeAttribute('disabled');
      this.errorMsg.style.display = '';
    }
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /** @param {string} phone */
  isValidPhone(phone) {
    return /^\+[1-9]\d{7,14}$/.test(phone);
  }
}

window.addEventListener('load', () => { new CustomBISPopup(); });
